<main class="container full-height d-flex flex-column justify-content-center">
  <p class="text-center text-danger">
    <i class="far fa-times-circle fa-4x"></i>
  </p>
  <h3 class="text-center" i18n>Order cancelled</h3>
  <div>
    <p class="text-center" i18n>Your order has been cancelled.</p>
    <p class="text-center">
      <button *ngIf="canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Close this window and go back to {{host.name}}</button>
      <button *ngIf="!canClose()" (click)="onBtClose($event)" class="btn btn-primary" i18n>Go back to {{host.name}}</button>
    </p>
  </div>
</main>
